import { LinkExternalIcon } from "@primer/octicons-react";
import { Box, Link, SegmentedControl } from "@primer/react";
import { useContext, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../hooks/useAuth";
import { useLocation } from "react-router-dom";
import { IMenuModel } from "../../models/response/account/user-info";
import { actions } from "../../state/actions/actionsWrapper";
import { RootState } from "../../state/reducers";
import { ILayoutContext, LayoutContext } from "../Layout";
import Button from "../../components/ui/button";
// Menu khớp cả route con: menu "cskh" khớp pathname "cskh/kho_lead"
const isPathMatch = (menuPath: string | undefined, path: string): boolean =>
  !!menuPath && (path === menuPath || path.startsWith(menuPath + "/"));
const IsHaveChidrenMatchPath = (
  rootMenu: IMenuModel,
  path: string
): boolean => {
  // debugger
  if (rootMenu.items.length > 0) {
    const menu = rootMenu.items.find(
      (x) => isPathMatch(x.path, path) || IsHaveChidrenMatchPath(x, path)
    );
    return menu !== undefined;
  } else {
    return isPathMatch(rootMenu.path, path);
  }
  return false;
};
const MenuGroup = () => {
  const { user_info } = useSelector((x: RootState) => x.auth);
  const { menu_group_id, language } = useSelector((x: RootState) => x.common);
  const dispatch = useDispatch();
  const { setHideSubNav } = useContext<ILayoutContext>(LayoutContext);
  const location = useLocation();
  const user = useAuth();
  const selectedMenu = useMemo(() => {
    const pathname = location.pathname.slice(1);
    var menu = user?.user_info?.menus.find((x) =>
      x.items.find((y) => isPathMatch(y.path, pathname))
    );
    if (menu) {
      var item = menu.items.find((y) => isPathMatch(y.path, pathname));
      if (item) {
        return item;
      }
    }
    return null;
  }, [user, location.pathname, user?.user_info?.menus]);
  useEffect(() => {
    const pathname = window.location.pathname.slice(1);
    if (menu_group_id === undefined) {
      let result: number = 0;
      user_info?.menus.forEach((rootMenu) => {
        if (result === 0) {
          const check = IsHaveChidrenMatchPath(rootMenu, pathname);
          if (check) {
            result = rootMenu.id;
          }
        }
      });
      dispatch(actions.common.changeMenuGroup(result));

      // if (menu) {
      //     if (menu.menu_parent_id === 0) {
      //         dispatch(actions.common.changeMenuGroup(menu.menu_parent_id))
      //     } else {
      //         const menuParent = user_info?.menus.find(x => x.id === menu.menu_parent_id)
      //         if (menuParent && menuParent.menu_parent_id === 0) {
      //             dispatch(actions.common.changeMenuGroup(menuParent.id))
      //         }
      //     }
      // }
    }
  }, [menu_group_id]);

  return (
    <>
      <Box
        sx={{
          pt: 1,
          pb: 1,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        {/* Empty box for left spacing */}
        <Box sx={{ width: "200px" }}></Box>

        {/* Center content */}
        {user_info && (
          <SegmentedControl
            onChange={(e) => {
              if (setHideSubNav) setHideSubNav(false);
              dispatch(actions.common.changeMenuGroup(user_info.menus[e].id));
            }}
            sx={
              {
                // backgroundColor: "red"
              }
            }
          >
            {user_info.menus.map((menu, index) => {
              const Icon = () => {
                return <i className={`${menu.icon}`}></i>;
              };
              return (
                <SegmentedControl.Button
                  selected={menu.id === menu_group_id}
                  leadingIcon={Icon}
                  sx={{
                    color: "#182C62",
                  }}
                >
                  {language === "en" ? menu.name_en : menu.name}
                </SegmentedControl.Button>
              );
            })}
          </SegmentedControl>
        )}

        {/* Right side button */}
        <Box
          sx={{
            display: "flex",
            mr: 4,
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Link
            href={selectedMenu?.user_guide_link ?? undefined}
            target="_blank"
          >
            <Button
              text="Hướng dẫn sử dụng"
              variant="invisible"
              sx={
                {
                  // color: "#fff"
                }
              }
              leadingVisual={LinkExternalIcon}
            />
          </Link>
        </Box>
        {/* <UnderlineNav aria-label="Repository" sx={{
                    borderBottom: 0,
                    borderBottomStyle: "solid",
                    borderColor: "border.default",
                    justifyContent: "center",
                    display: "flex",
                    width: "100%"

                }}>
                    {user_info && <>
                        {user_info.menus.map((menu, index) => {
                            const Icon = () => {
                                return <i className={`${menu.icon}`}></i>
                            }
                            return (
                                <UnderlineNav.Item key={index}
                                    // icon={Icon}

                                    aria-current={menu.id === menu_group_id}
                                    onSelect={() => {
                                        dispatch(actions.common.changeMenuGroup(menu.id))
                                    }}
                                    className={clsx(styles.item, menu.id === menu_group_id ? styles.selected : "")}

                                >
                                    <Box sx={{
                                        display: "flex"
                                    }}>
                                        <Box sx={{ mr: 1 }}><Icon /></Box>
                                        <Box> {language === "en" ? menu.name_en : menu.name}</Box>
                                        {menu.tags &&
                                            <Box sx={{ ml: 1 }}>
                                                <Label variant='success'>
                                                    {menu.tags}
                                                </Label>
                                            </Box>
                                        }
                                    </Box>
                                </UnderlineNav.Item>
                            )
                        })}
                    </>}


                </UnderlineNav> */}
      </Box>
    </>
  );
};

export default MenuGroup;
